import { render, staticRenderFns } from "./CopyInstance.vue?vue&type=template&id=036c893f&scoped=true"
import script from "./CopyInstance.vue?vue&type=script&lang=js"
export * from "./CopyInstance.vue?vue&type=script&lang=js"
import style0 from "./CopyInstance.vue?vue&type=style&index=0&id=036c893f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036c893f",
  null
  
)

export default component.exports